module.exports = __webpack_public_path__ + "img/tp1.d9b79baa.png";